import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { SharedDataService } from '../shared-data.service';
import { ConfigurationDataService } from '../configuration-data.service';
import { Router } from '@angular/router';


@Injectable()
export class LoginGuard implements CanActivate {

  constructor(private shared : SharedDataService, private config : ConfigurationDataService, private router : Router) {

}

 /**
  * Protects routes against authorized access.
  */
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      console.log("Login-Guard is called, is logged in:" + this.shared.getLoginData().isLoggedIn)
      if(!this.shared.getLoginData().isLoggedIn)
      {
        this.router.navigateByUrl('/login');
      }
      return this.shared.getLoginData().isLoggedIn;
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/login/login.guard.ts